/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import cn from 'classnames';
import { getProjectScore, getFullScore } from 'helpers';
import { PREV_TCAS_LABEL } from 'constants/school-year';
import PassChance from './PassChance';

// Hooks
import { useSelector } from 'react-redux';
import useAdmission from 'hooks/round3/useAdmission';
import useIsMobile from 'hooks/useIsMobile';

const ModalChooseRound3 = ({ visible, favorites, studentStatus, onSelect, onClose }) => {
  const profile = useSelector((state) => _.get(state, 'app.user') || {});
  const courseMap = useSelector((state) => _.get(state, 'app.courseMap')) || {};
  const admissionCountMap = useSelector((state) => _.get(state, 'app.admissionCountMap')) || {};
  const { availables, nextPriority } = useAdmission(favorites, studentStatus, { draft: true });

  const [favoriteId, setfavoriteId] = useState();
  // ต้องเป็นตัวที่เลือกได้ตอนนี้จริง — id ค้างจากรอบก่อน (ติดอันดับไปแล้ว) ห้ามยืนยันซ้ำ
  const disabled = !favoriteId || !availables.some(({ _id }) => _id === favoriteId);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (visible) {
      setfavoriteId(undefined); // component ไม่ unmount ตอนปิด — ล้างตัวเลือกค้างทุกครั้งที่เปิด
      document.body.style.overflow = 'hidden';
    } else {
      document.body.removeAttribute('style');
    }
  }, [visible]);

  const _onSelect = () => {
    onSelect(favoriteId, nextPriority);
    onClose();
  }

  if (!visible) return null;
  return (
    <div className="t-modal -scroll" style={{ visibility: 'visible', opacity: 1 }}>
      <div className="content" style={{ opacity: 1, height: 'initial', padding: 20, overflowY: 'auto' }}>
        <div className="text-center">
          <h1 className="color-blue">{'อันดับที่'} {nextPriority}</h1>
          <h4 className="sub">{'กรุณาเลือกสาขาวิชาที่จะสมัคร'}</h4>
          <ul className="r-choose">
            {(availables || []).map((row, index) => {
              const lang = 'th';
              const project = courseMap[row.program_project];
              const majorName = _.get(project, `major_name_${lang}`);
              const projectName = _.get(project, `project_name_${lang}`);
              if (!project) return null;
              const admissionCountKey = `${project.program_id || 0}_${project.major_id || 0}_${project.project_id || 0}`;
              return (
                <li key={project._id}>
                  <label style={{ paddingBottom: isMobile ? 60 : 40 }}>
                    <div className="num"><b>{index + 1}</b></div>
                    <input
                      type="radio"
                      name="r-3"
                      checked={favoriteId === row._id}
                      onChange={() => setfavoriteId(row._id)} />
                    <h4 className="score" style={isMobile ? { bottom: 38 } : {}}>
                      {'คะแนน'} {getProjectScore(profile, project, nextPriority)}/{getFullScore(project)}
                      <PassChance score={getProjectScore(profile, project, nextPriority)} project={project} />
                    </h4>
                    <h4
                      className="score"
                      style={isMobile
                        ? { right: 'auto', left: 'auto', bottom: 16, textAlign: 'left', pointerEvents: 'none' }
                        : { right: 16, left: 'auto', pointerEvents: 'none' }}
                    >
                      {`จำนวนผู้สมัคร ${(admissionCountMap[admissionCountKey] || 0).toLocaleString()} คน`}
                      {Number(_.get(project, 'last_year_register')) ? (
                        <span style={{ color: '#999' }}>{` (${PREV_TCAS_LABEL} : ${Number(_.get(project, 'last_year_register')).toLocaleString()} คน)`}</span>
                      ) : null}
                    </h4>
                    <span
                      className="u-logo"
                      style={{ backgroundImage: `url('/assets/img/logo/${_.get(project, 'university_id')}.png')` }}
                    />
                    <strong>{_.get(project, `university_name_${lang}`)}</strong>
                    {_.get(project, `campus_name_${lang}`)}
                    <br />
                    {_.get(project, `faculty_name_${lang}`)}
                    <br />
                    {_.get(project, `field_name_${lang}`)}
                    <br />
                    {majorName && majorName !== '0' ? (
                      <>
                        {'วิชาเอก'}
                        {majorName}
                        <br />
                      </>
                    ) : null}
                    {_.get(project, `program_name_${lang}`)}
                    <br />
                    {lang === 'th' ? `(${_.get(project, `program_type_name_th`)})` : null}
                    {projectName && projectName !== '0' ? (
                      <>
                        <br />
                        {'โครงการ '}
                        {projectName}
                      </>
                    ) : null}
                  </label>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="_space"></div>
        <div className="content-bottom">
          <a className="btn-cancel cursor-pointer" onClick={onClose}>
            <span className="icon">×</span> {'ยกเลิก'}
          </a>
          <a className={cn('btn-main', { disabled, 'cursor-pointer': !disabled })} onClick={disabled ? () => { } : _onSelect}> {'ยืนยัน'}</a>
        </div>
      </div>
    </div >
  );
};

export default ModalChooseRound3;
